/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from "react";

interface LightboxProps {
  readonly imageUrl: string;
  readonly altText: string;
  readonly width: number;
  readonly height: number;
  readonly onClose: () => void;
}

const Lightbox: React.FC<LightboxProps> = ({ imageUrl, altText, width, height, onClose }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 10);

    return (): void => clearTimeout(timer);
  }, []);

  return (
    <div
      className="lightbox"
      data-image-is-loaded={isLoaded.toString()}
      role="button"
      tabIndex={0}
      title="Click to close"
      onClick={onClose}
      onKeyDown={onClose}
    >
      <div className="lightbox-image-frame">
        <img
          alt={altText}
          decoding="async"
          height={height}
          loading="eager"
          src={imageUrl}
          width={width}
        />
      </div>
    </div>
  );
};

export default Lightbox;
